import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IMeetingsDAO } from '../../../../api/meetings.dao';

export class MeetingsUploadJob extends JobConfiguration {
    public readonly type = JobType.MeetingsUpload;
    public readonly name = 'Upload Schedule';
    public readonly description = 'Meetings Import';

    public async execute(execParams) {
        return IoC.Container.get(IMeetingsDAO).importMeetings(execParams);
    }
}

export default {
    [JobType.MeetingsUpload]: MeetingsUploadJob
};
